/**
 * Instrument Serif Stroke Detection and Application
 * Automatically applies stroke to text when Instrument Serif font is detected
 */

(function() {
  'use strict';

  // Function to calculate stroke width based on font size
  function calculateStrokeWidth(fontSize) {
    // Convert font size to number and calculate 1% of it
    const size = parseFloat(fontSize);
    return size * 0.01;
  }

  // Function to apply stroke to an element
  function applyStrokeToElement(element) {
    const computedStyle = window.getComputedStyle(element);
    const fontFamily = computedStyle.getPropertyValue('font-family');
    
    // Check if the font family contains Instrument Serif
    if (fontFamily.includes('Instrument Serif')) {
      const fontSize = computedStyle.getPropertyValue('font-size');
      const strokeWidth = calculateStrokeWidth(fontSize);
      
      // Apply stroke
      element.style.webkitTextStroke = strokeWidth + 'px';
      element.style.textStroke = strokeWidth + 'px';
      
      // Add a class for additional styling if needed
      element.classList.add('instrument-serif-stroke-applied');
    }
  }

  // Function to process all text elements
  function processAllElements() {
    // Select all elements that might contain text
    const textElements = document.querySelectorAll('h1, h2, h3, h4, h5, h6, p, span, div, a, button, label');
    
    textElements.forEach(function(element) {
      applyStrokeToElement(element);
    });
  }

  // Function to observe DOM changes and apply stroke to new elements
  function observeDOMChanges() {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              // Apply stroke to the new element
              applyStrokeToElement(node);
              
              // Also check child elements
              const childElements = node.querySelectorAll('h1, h2, h3, h4, h5, h6, p, span, div, a, button, label');
              childElements.forEach(function(child) {
                applyStrokeToElement(child);
              });
            }
          });
        }
      });
    });

    // Start observing
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Function to handle font loading
  function handleFontLoading() {
    if ('fonts' in document) {
      document.fonts.ready.then(function() {
        // Fonts are loaded, now process elements
        processAllElements();
      });
    } else {
      // Fallback for browsers that don't support Font Loading API
      setTimeout(processAllElements, 1000);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      handleFontLoading();
      observeDOMChanges();
    });
  } else {
    // DOM is already ready
    handleFontLoading();
    observeDOMChanges();
  }

  // Also handle window load for any late-loading fonts
  window.addEventListener('load', function() {
    processAllElements();
  });

  // Expose functions globally for manual use if needed
  window.InstrumentSerifStroke = {
    applyStroke: applyStrokeToElement,
    processAll: processAllElements,
    calculateStroke: calculateStrokeWidth
  };

})(); 